import moment from "moment";
import notification from "antd/lib/notification";
import { WDQMS_API, fetchData } from "../../utils/api";
import { variablesSlug } from "../../utils/general";
import { isEmpty, setError404 } from "../actions/actions";
import {
  setProperty,
  setPeriodDataKey,
  updatePeriodTypes
} from "../actions/actions";

// Marine report types
export const MARINE_REPORT_TYPES = {
  quality: [
    {
      code: "110",
      description: "pressure"
    },
    {
      code: "39",
      description: "temperature"
    },
    {
      code: "41",
      description: "zonal_wind"
    },
    {
      code: "42",
      description: "meridional_wind"
    },
    {
      code: "58",
      description: "humidity"
    }
  ]
};

// Main marine data fetching function for marine module
export const fetchMarineDataFromApi = (payload, pageType) => {
  // differentiate between requests coming from the map and from the database status
  if (pageType == "DB_STATUS") {
    pageType = "&page_type=DB_STATUS";
  }
  return dispatch => {
    let sixHourFetched;
    // If we have URL params, set them to the selected
    // params for the menu and map
    if (!isEmpty(payload.params)) {
      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedPeriodType",
          value: payload.params.periodType
        })
      );

      if (payload.fileType === "buoy") {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedReport",
            value: "quality"
          })
        );
      } else if (payload.fileType === "ship") {
        if (payload.params.variable) {
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "selectedReport",
              value: "quality"
            })
          );
        } else {
          // Otherwise, the report is "availability"
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "selectedReport",
              value: "availability"
            })
          );
        }
      }
      if (payload.params.variable) {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedVariable",
            value: variablesSlug[payload.fileType]?.[payload.params.variable] ?? payload.params.variable
          })
        );
      }

      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedCenter",
          value: payload.params.center
        })
      );

      if (payload.params.center !== "all") {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "combinedMode",
            value: false
          })
        );
      }

      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedDate",
          value: payload.params.date
        })
      );
    }
    if (!payload.alreadyFetched) {
      fetchSixhourMarinePeriod();
    } else {
      // console.log(`${payload.fileType} data already fetched`);
    }

    function fetchSixhourMarinePeriod() {
      return fetchData(
        `${WDQMS_API}/sixhour-periods/?file_type=${payload.fileType}&format=json`
      )
        .then(response => {
          // response.data.length === 0 -> NO DATA
          if (response.data.length === 0) {
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "six_hour",
                key: "noData",
                value: true
              })
            );
            // set the data (for a particular fileType) as fetched
            // so that won't be fetched a second time
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "dataFetched",
                value: true
              })
            );
          } else {
            sixHourFetched = true;
            if (isEmpty(payload.params)) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedPeriodType",
                  value: "six_hour"
                })
              );
            }

            dispatch(
              updatePeriodTypes({
                type: payload.fileType,
                value: "six_hour"
              })
            );
            // }
            let tempObj = {};
            for (let p of response.data.results) {
              if (!tempObj[p.center]) {
                tempObj[p.center] = {};
              }
              if (!tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")]) {
                tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")] = {
                  "00": { available: false, id: null },
                  "06": { available: false, id: null },
                  "12": { available: false, id: null },
                  "18": { available: false, id: null }
                };
              }
              tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")][
                moment.utc(p.date).format("HH")
              ].available = true;
              tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")][
                moment.utc(p.date).format("HH")
              ].id = p.id;
            }
            // The object that contains the dates for the 'combined' version (all centers)
            let objectAll = {};
            // loop through all centers
            for (let ct of Object.keys(tempObj)) {
              // loop through all dates
              for (let d of Object.keys(tempObj[ct])) {
                // if objectAll doesn't have the key 'd'
                if (!Object.keys(objectAll).includes(d)) {
                  objectAll[d] = {};
                  // loop through the 4 six-hour periods
                  for (let p of Object.keys(tempObj[ct][d])) {
                    if (tempObj[ct][d][p].available) {
                      objectAll[d][p] = {};
                      objectAll[d][p].available = true;
                      objectAll[d][p].id = {};
                      objectAll[d][p].id[ct] = tempObj[ct][d][p].id;
                    } else {
                      objectAll[d][p] = {
                        available: false,
                        id: {}
                      };
                    }
                  }
                } else {
                  for (let p of Object.keys(tempObj[ct][d])) {
                    if (tempObj[ct][d][p].available) {
                      objectAll[d][p].available = true;
                      objectAll[d][p].id[ct] = tempObj[ct][d][p].id;
                    }
                  }
                }
              }
            }
            tempObj.all = objectAll;

            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "six_hour",
                key: "dates",
                value: tempObj
              })
            );
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "six_hour",
                key: "centers",
                // case insensitive sort so that "all" is first element
                value: Object.keys(tempObj).sort(function(a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                })
              })
            );

            let latestDate;
            let availablePeriods;
            if (isEmpty(payload.params)) {
              const firstCenter = Object.keys(tempObj).sort(function(a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
              })[0];
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedCenter",
                  value: firstCenter
                })
              );

              latestDate = Object.keys(tempObj[firstCenter]).sort()[
                Object.keys(tempObj[firstCenter]).length - 1
              ];
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedDate",
                  value: latestDate
                })
              );

              availablePeriods = tempObj[firstCenter][latestDate];

              const arrAvailablePeriods = Object.keys(availablePeriods)
                .sort()
                .filter(p => availablePeriods[p].available);

              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedSixHPeriod",
                  value: arrAvailablePeriods[arrAvailablePeriods.length - 1]
                })
              );
            } else if (payload.params.periodType === "six_hour") {
              latestDate = payload.params.date;
              // check if the date exist
              if (tempObj[payload.params.center][latestDate]) {
                availablePeriods = tempObj[payload.params.center][latestDate];

                dispatch(
                  setProperty({
                    type: payload.fileType,
                    key: "selectedSixHPeriod",
                    value: payload.params.period
                  })
                );

                // if the date doesn't exist, trigger an error
              } else {
                dispatch(setError404());
              }

              // if the six-hour period is not available for this date,
              // also trigger an error
              if (
                tempObj[payload.params.center][latestDate] &&
                typeof payload.params.period !== "undefined"
              ) {
                if (!availablePeriods[payload.params.period].available) {
                  dispatch(setError404());
                }
              }
            }

            dispatch(
              setProperty({
                type: payload.fileType,
                key: "currentSixHPeriods",
                value: availablePeriods
              })
            );

            if (
              isEmpty(payload.params) ||
              payload.params.periodType === "six_hour"
            ) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "readyToFillMenu",
                  value: true
                })
              );
            }

            // set the data (for a particular fileType) as fetched
            // so that won't be fetched a second time
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "dataFetched",
                value: true
              })
            );
          }
        })
        .catch(error => {
          // If there are URL params requesting the six-hour data
          // and an error while fetching the six-hour data, trigger an error
          if (
            !isEmpty(payload.params) &&
            payload.params.periodType === "six_hour"
          ) {
            dispatch(setError404());
          }

          sixHourFetched = false;

          notification.error({
            message: "Error fetching API",
            description: "There was an error while fetching the six-hour data",
            top: 100,
            duration: 0
          });
          dispatch(
            setPeriodDataKey({
              subObj: "periodData",
              type: payload.fileType,
              period: "six_hour",
              key: "errorFetchingApi",
              value: true
            })
          );
        });
    }
  };
};

// Combined marine surface data fetching function for marine_surface file type
export const fetchBuoyShipMarineDataFromApi = (payload, pageType) => {
  // Fetching combined marine and buoy togeather.
  if (pageType == "DB_STATUS") {
    pageType = "&page_type=DB_STATUS";
  }
  return dispatch => {
    let sixHourFetched;
    let dailyFetched;
    // If we have URL params, set them to the selected
    // params for the menu and map
    if (!isEmpty(payload.params)) {
      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedPeriodType",
          value: payload.params.periodType
        })
      );

      if (payload.fileType === "marine_surface") {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedReport",
            value: "quality"
          })
        );
      }
      if (payload.params.variable) {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedVariable",
            value: variablesSlug[payload.fileType]?.[payload.params.variable] ?? payload.params.variable
          })
        );
      }

      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedCenter",
          value: payload.params.center
        })
      );

      if (payload.params.center !== "all") {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "combinedMode",
            value: false
          })
        );
      }

      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedDate",
          value: payload.params.date
        })
      );
    }
    if (!payload.alreadyFetched) {
      fetchSixhourBuoyShipMarinePeriod().then(response => {
        fetchDailyBuoyShipMarinePeriod().then(response => {
          fetchMonthlyBuoyShipMarinePeriod();
        });
      });
    } else {
      // console.log(`${payload.fileType} data already fetched`);
    }

    function fetchSixhourBuoyShipMarinePeriod() {
      return fetchData(
        `${WDQMS_API}/sixhour-periods/?file_type=${payload.fileType}&format=json`
      )
        .then(response => {
          // console.log("response", response);
          // response.data.length === 0 -> NO DATA
          if (response.data.results.length === 0) {
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "six_hour",
                key: "noData",
                value: true
              })
            );
            // set the data (for a particular fileType) as fetched
            // so that won't be fetched a second time
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "dataFetched",
                value: true
              })
            );
          } else {
            sixHourFetched = true;
            if (isEmpty(payload.params)) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedPeriodType",
                  value: "six_hour"
                })
              );
            }

            dispatch(
              updatePeriodTypes({
                type: payload.fileType,
                value: "six_hour"
              })
            );
            // }

            let tempObj = {};
            for (let p of response.data.results) {
              if (!tempObj[p.center]) {
                tempObj[p.center] = {};
                tempObj[p.center][p.file_type] = {};
              } else if (!tempObj[p.center][p.file_type]) {
                tempObj[p.center][p.file_type] = {};
              }

              if (
                !tempObj[p.center][p.file_type][
                  moment.utc(p.date).format("YYYY-MM-DD")
                ]
              ) {
                tempObj[p.center][p.file_type][
                  moment.utc(p.date).format("YYYY-MM-DD")
                ] = {
                  "00": { available: false, id: null },
                  "06": { available: false, id: null },
                  "12": { available: false, id: null },
                  "18": { available: false, id: null }
                };
              }

              tempObj[p.center][p.file_type][
                moment.utc(p.date).format("YYYY-MM-DD")
              ][moment.utc(p.date).format("HH")].available = true;
              tempObj[p.center][p.file_type][
                moment.utc(p.date).format("YYYY-MM-DD")
              ][moment.utc(p.date).format("HH")].id = p.id;
            }

            // The object that contains the dates for the 'combined' version (all centers)
            let objectAll = {};
            // loop through all centers
            for (let ct of Object.keys(tempObj)) {
              // loop through buoy and ship
              for (let f_type of Object.keys(tempObj[ct])) {
                // loop through all dates
                if (!Object.keys(objectAll).includes(f_type)) {
                  objectAll[f_type] = {};
                }
                for (let d of Object.keys(tempObj[ct][f_type])) {
                  // if objectAll doesn't have the key 'd'
                  if (!Object.keys(objectAll[f_type]).includes(d)) {
                    objectAll[f_type][d] = {};

                    // loop through the 4 six-hour periods
                    for (let p of Object.keys(tempObj[ct][f_type][d])) {
                      // console.log("tempObj[ct][f_type][d][p]", tempObj[ct][f_type][d][p]);
                      if (tempObj[ct][f_type][d][p].available) {
                        // if objectAll[f_type][d][p] is not defined, define it
                        objectAll[f_type][d][p] = {};
                        objectAll[f_type][d][p].available = true;
                        objectAll[f_type][d][p].id = {};

                        objectAll[f_type][d][p].id[ct] =
                          tempObj[ct][f_type][d][p].id;
                      } else {
                        objectAll[f_type][d][p] = {
                          available: false,
                          id: {}
                        };
                      }
                    }
                  } else {
                    for (let p of Object.keys(tempObj[ct][f_type][d])) {
                      if (tempObj[ct][f_type][d][p].available) {
                        objectAll[f_type][d][p].available = true;
                        objectAll[f_type][d][p].id[ct] =
                          tempObj[ct][f_type][d][p].id;
                      }
                    }
                  }
                }
              }
            }
            tempObj.all = objectAll;

            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "six_hour",
                key: "dates",
                value: tempObj
              })
            );
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "six_hour",
                key: "centers",
                // case insensitive sort so that "all" is first element
                value: Object.keys(tempObj).sort(function(a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                })
              })
            );

            let latestDate;
            let availablePeriods;
            if (isEmpty(payload.params)) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedPeriodType",
                  value: "six_hour"
                })
              );

              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedCenter",
                  value: "all"
                })
              );

              const firstFileType = Object.keys(tempObj["all"]).sort()[0];
              latestDate = Object.keys(tempObj["all"][firstFileType]).sort()[
                Object.keys(tempObj["all"][firstFileType]).length - 1
              ];

              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedDate",
                  value: latestDate
                })
              );

              availablePeriods = tempObj["all"][firstFileType][latestDate];

              const arrAvailablePeriods = Object.keys(availablePeriods)
                .sort()
                .filter(p => availablePeriods[p].available);

              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedSixHPeriod",
                  value: arrAvailablePeriods[arrAvailablePeriods.length - 1]
                })
              );
            } else if (payload.params.periodType === "six_hour") {
              latestDate = payload.params.date;
              // check if the date exist
              if (tempObj[payload.params.center]["BUOY"][latestDate]) {
                availablePeriods =
                  tempObj[payload.params.center]["BUOY"][latestDate];

                dispatch(
                  setProperty({
                    type: payload.fileType,
                    key: "selectedSixHPeriod",
                    value: payload.params.period
                  })
                );

                // if the date doesn't exist, trigger an error
              } else {
                dispatch(setError404());
              }

              // if the six-hour period is not available for this date,
              // also trigger an error
              if (
                tempObj[payload.params.center]["BUOY"][latestDate] &&
                typeof payload.params.period !== "undefined"
              ) {
                if (!availablePeriods[payload.params.period].available) {
                  dispatch(setError404());
                }
              }
            }

            dispatch(
              setProperty({
                type: payload.fileType,
                key: "currentSixHPeriods",
                value: availablePeriods
              })
            );

            if (
              isEmpty(payload.params) ||
              payload.params.periodType === "six_hour"
            ) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "readyToFillMenu",
                  value: true
                })
              );
            }

            // set the data (for a particular fileType) as fetched
            // so that won't be fetched a second time
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "dataFetched",
                value: true
              })
            );
          }
        })
        .catch(error => {
          // If there are URL params requesting the six-hour data
          // and an error while fetching the six-hour data, trigger an error
          if (
            !isEmpty(payload.params) &&
            payload.params.periodType === "six_hour"
          ) {
            dispatch(setError404());
          }
          console.log(error);
          sixHourFetched = false;

          notification.error({
            message: "Error fetching API",
            description: "There was an error while fetching the six-hour data",
            top: 100,
            duration: 0
          });
          dispatch(
            setPeriodDataKey({
              subObj: "periodData",
              type: payload.fileType,
              period: "six_hour",
              key: "errorFetchingApi",
              value: true
            })
          );
        });
    }

    function fetchDailyBuoyShipMarinePeriod() {
      return fetchData(
        `${WDQMS_API}/daily-periods/?file_type=${payload.fileType}`
      )
        .then(response => {
          if (response.data.length === 0) {
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "daily",
                key: "noData",
                value: true
              })
            );
          } else {
            dailyFetched = true;
            if (!sixHourFetched) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedPeriodType",
                  value: "daily"
                })
              );
            }
            dispatch(
              updatePeriodTypes({
                type: payload.fileType,
                value: "daily"
              })
            );
            let tempObj = {};
            for (let p of response.data) {
              if (!tempObj[p.center]) {
                tempObj[p.center] = {};
              }
              if (!tempObj[p.center][p.file_type]) {
                tempObj[p.center][p.file_type] = {};
              }
              tempObj[p.center][p.file_type][
                moment.utc(p.date).format("YYYY-MM-DD")
              ] = { id: p.id };
            }
            let objectAll = {};
            for (let ct of Object.keys(tempObj)) {
              for (let f_type of Object.keys(tempObj[ct])) {
                if (!Object.keys(objectAll).includes(f_type)) {
                  objectAll[f_type] = {};
                }
                for (let d of Object.keys(tempObj[ct][f_type])) {
                  if (!Object.keys(objectAll[f_type]).includes(d)) {
                    objectAll[f_type][d] = {};
                  }
                  objectAll[f_type][d][ct] = tempObj[ct][f_type][d].id;
                }
              }
            }
            tempObj.all = objectAll;
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "daily",
                key: "dates",
                value: tempObj
              })
            );
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "daily",
                key: "centers",
                value: Object.keys(tempObj).sort(function(a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                })
              })
            );
            if (
              !isEmpty(payload.params) &&
              payload.params.periodType === "daily"
            ) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedCenter",
                  value: payload.params.center
                })
              );
              const firstFileType = Object.keys(
                tempObj[payload.params.center]
              ).sort()[0];
              if (
                !tempObj[payload.params.center][firstFileType][
                  payload.params.date
                ]
              ) {
                const latestDate = Object.keys(
                  tempObj[payload.params.center][firstFileType]
                ).sort()[
                  Object.keys(tempObj[payload.params.center][firstFileType])
                    .length - 1
                ];
                dispatch(
                  setProperty({
                    type: payload.fileType,
                    key: "selectedDate",
                    value: latestDate
                  })
                );
              } else {
                dispatch(
                  setProperty({
                    type: payload.fileType,
                    key: "selectedDate",
                    value: payload.params.date
                  })
                );
              }
            } else if (!sixHourFetched) {
              const firstCenter = Object.keys(tempObj)
                .filter(k => k !== "all")
                .sort(function(a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                })[0];
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedCenter",
                  value: firstCenter
                })
              );
              const firstFileType = Object.keys(
                tempObj[firstCenter]
              ).sort()[0];
              const latestDate = Object.keys(
                tempObj[firstCenter][firstFileType]
              ).sort()[
                Object.keys(tempObj[firstCenter][firstFileType]).length - 1
              ];
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedDate",
                  value: latestDate
                })
              );
            }
            if (
              isEmpty(payload.params) ||
              payload.params.periodType === "daily"
            ) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "readyToFillMenu",
                  value: true
                })
              );
            }
          }
        })
        .catch(error => {
          if (
            !isEmpty(payload.params) &&
            payload.params.periodType === "daily"
          ) {
            dispatch(setError404());
          }
          notification.error({
            message: "Error fetching API",
            description: "There was an error while fetching the daily data",
            top: 100,
            duration: 0
          });
          dispatch(
            setPeriodDataKey({
              subObj: "periodData",
              type: payload.fileType,
              period: "daily",
              key: "errorFetchingApi",
              value: true
            })
          );
        });
    }

    function fetchMonthlyBuoyShipMarinePeriod() {
      return fetchData(
        `${WDQMS_API}/monthly-periods/?file_type=${payload.fileType}`
      )
        .then(response => {
          if (response.data.length === 0) {
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "monthly",
                key: "noData",
                value: true
              })
            );
          } else {
            if (!dailyFetched) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedPeriodType",
                  value: "monthly"
                })
              );
            }
            dispatch(
              updatePeriodTypes({
                type: payload.fileType,
                value: "monthly"
              })
            );
            let tempObj = {};
            for (let p of response.data) {
              if (!tempObj[p.center]) {
                tempObj[p.center] = {};
              }
              if (!tempObj[p.center][p.file_type]) {
                tempObj[p.center][p.file_type] = {};
              }
              tempObj[p.center][p.file_type][
                moment.utc(p.date).format("YYYY-MM")
              ] = { id: p.id };
            }
            let objectAll = {};
            for (let ct of Object.keys(tempObj)) {
              for (let f_type of Object.keys(tempObj[ct])) {
                if (!Object.keys(objectAll).includes(f_type)) {
                  objectAll[f_type] = {};
                }
                for (let d of Object.keys(tempObj[ct][f_type])) {
                  if (!Object.keys(objectAll[f_type]).includes(d)) {
                    objectAll[f_type][d] = {};
                  }
                  objectAll[f_type][d][ct] = tempObj[ct][f_type][d].id;
                }
              }
            }
            tempObj.all = objectAll;
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "monthly",
                key: "dates",
                value: tempObj
              })
            );
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "monthly",
                key: "centers",
                value: Object.keys(tempObj).sort(function(a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                })
              })
            );
            if (
              !isEmpty(payload.params) &&
              payload.params.periodType === "monthly"
            ) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedCenter",
                  value: payload.params.center
                })
              );
              const firstFileType = Object.keys(
                tempObj[payload.params.center]
              ).sort()[0];
              if (
                !tempObj[payload.params.center][firstFileType][
                  payload.params.date
                ]
              ) {
                const latestDate = Object.keys(
                  tempObj[payload.params.center][firstFileType]
                ).sort()[
                  Object.keys(tempObj[payload.params.center][firstFileType])
                    .length - 1
                ];
                dispatch(
                  setProperty({
                    type: payload.fileType,
                    key: "selectedDate",
                    value: latestDate
                  })
                );
              } else {
                dispatch(
                  setProperty({
                    type: payload.fileType,
                    key: "selectedDate",
                    value: payload.params.date
                  })
                );
              }
            } else if (!dailyFetched) {
              const firstCenter = Object.keys(tempObj)
                .filter(k => k !== "all")
                .sort(function(a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                })[0];
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedCenter",
                  value: firstCenter
                })
              );
              const firstFileType = Object.keys(
                tempObj[firstCenter]
              ).sort()[0];
              const latestDate = Object.keys(
                tempObj[firstCenter][firstFileType]
              ).sort()[
                Object.keys(tempObj[firstCenter][firstFileType]).length - 1
              ];
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "selectedDate",
                  value: latestDate
                })
              );
            }
            if (
              isEmpty(payload.params) ||
              payload.params.periodType === "monthly"
            ) {
              dispatch(
                setProperty({
                  type: payload.fileType,
                  key: "readyToFillMenu",
                  value: true
                })
              );
            }
          }
        })
        .catch(error => {
          if (
            !isEmpty(payload.params) &&
            payload.params.periodType === "monthly"
          ) {
            dispatch(setError404());
          }
          notification.error({
            message: "Error fetching API",
            description: "There was an error while fetching the monthly data",
            top: 100,
            duration: 0
          });
          dispatch(
            setPeriodDataKey({
              subObj: "periodData",
              type: payload.fileType,
              period: "monthly",
              key: "errorFetchingApi",
              value: true
            })
          );
        });
    }
    // function fetchDailyBuoyShipMarinePeriod() {
    //   return fetchData(
    //     `${WDQMS_API}/daily-periods/?file_type=${payload.fileType}&format=json`
    //   )
    //     .then(response => {
    //       // response.data.length === 0 -> NO DATA
    //       if (response.data.length === 0) {
    //         dispatch(
    //           setPeriodDataKey({
    //             subObj: "periodData",
    //             type: payload.fileType,
    //             period: "daily",
    //             key: "noData",
    //             value: true
    //           })
    //         );
    //       } else {
    //         // if there was an error while fetching the six-hour or params are empty
    //         // set the selected period type to "daily"
    //         dailyFetched = true;
    //         if (!sixHourFetched) {
    //           dispatch(
    //             setProperty({
    //               type: payload.fileType,
    //               key: "selectedPeriodType",
    //               value: "daily"
    //             })
    //           );
    //         }

    //         dispatch(
    //           updatePeriodTypes({
    //             type: payload.fileType,
    //             value: "daily"
    //           })
    //         );
    //         let tempObj = {};
    //         for (let p of response.data.results) {
    //           if (!tempObj[p.center]) {
    //             tempObj[p.center] = {};
    //             tempObj[p.center][p.file_type] = {};
    //           } else if (!tempObj[p.center][p.file_type]) {
    //             tempObj[p.center][p.file_type] = {};
    //           }

    //           tempObj[p.center][p.file_type][
    //             moment.utc(p.date).format("YYYY-MM-DD")
    //           ] = {
    //             id: p.id
    //           };
    //         }
    //         // The object that contains the dates for the 'combined' version (all centers)
    //         let objectAll = {};
    //         // loop through all centers
    //         for (let ct of Object.keys(tempObj)) {
    //           // loop through buoy and ship
    //           for (let f_type of Object.keys(tempObj[ct])) {
    //             // loop through all dates
    //             if (!Object.keys(objectAll).includes(f_type)) {
    //               objectAll[f_type] = {};
    //             }
    //             for (let d of Object.keys(tempObj[ct][f_type])) {
    //               // if the date is not in arrayAll, add it
    //               // if objectAll doesn't have the key 'd'
    //               if (!Object.keys(objectAll[f_type]).includes(d)) {
    //                 objectAll[f_type][d] = {};
    //               }
    //               objectAll[f_type][d][ct] = tempObj[ct][f_type][d].id;
    //             }
    //           }
    //         }
    //         // Add objectAll to tempObj
    //         tempObj.all = objectAll;

    //         dispatch(
    //           setPeriodDataKey({
    //             subObj: "periodData",
    //             type: payload.fileType,
    //             period: "daily",
    //             key: "dates",
    //             value: tempObj
    //           })
    //         );

    //         dispatch(
    //           setPeriodDataKey({
    //             subObj: "periodData",
    //             type: payload.fileType,
    //             period: "daily",
    //             key: "centers",
    //             value: Object.keys(tempObj).sort(function(a, b) {
    //               return a.toLowerCase().localeCompare(b.toLowerCase());
    //             })
    //           })
    //         );

    //         if (
    //           !isEmpty(payload.params) &&
    //           payload.params.periodType === "daily"
    //         ) {
    //           dispatch(
    //             setProperty({
    //               type: payload.fileType,
    //               key: "selectedCenter",
    //               value: payload.params.center
    //             })
    //           );

    //           // if the date doesn't exist for this center,
    //           // set "selectedDate" to its latest date
    //           // note: it can happen that a date is available
    //           // for the six-hour periods but not for the daily
    //           if (!tempObj[payload.params.center][payload.params.date]) {
    //             const latestDate = Object.keys(
    //               tempObj[payload.params.center]
    //             ).sort()[
    //               Object.keys(tempObj[payload.params.center]).length - 1
    //             ];

    //             dispatch(
    //               setProperty({
    //                 type: payload.fileType,
    //                 key: "selectedDate",
    //                 value: latestDate
    //               })
    //             );
    //           } else {
    //             dispatch(
    //               setProperty({
    //                 type: payload.fileType,
    //                 key: "selectedDate",
    //                 value: payload.params.date
    //               })
    //             );
    //           }
    //         } else if (!sixHourFetched) {
    //           // Case no param - this should only be done
    //           // when there was an error fetching the six-hour data
    //           const firstCenter = Object.keys(tempObj).sort(function(a, b) {
    //             return a.toLowerCase().localeCompare(b.toLowerCase());
    //           })[0];

    //           dispatch(
    //             setProperty({
    //               type: payload.fileType,
    //               key: "selectedCenter",
    //               value: firstCenter
    //             })
    //           );

    //           const latestDate = Object.keys(tempObj[firstCenter]).sort()[
    //             Object.keys(tempObj[firstCenter]).length - 1
    //           ];

    //           dispatch(
    //             setProperty({
    //               type: payload.fileType,
    //               key: "selectedDate",
    //               value: latestDate
    //             })
    //           );
    //         }
    //         if (
    //           isEmpty(payload.params) ||
    //           payload.params.periodType === "daily"
    //         ) {
    //           dispatch(
    //             setProperty({
    //               type: payload.fileType,
    //               key: "readyToFillMenu",
    //               value: true
    //             })
    //           );
    //         }
    //       }
    //     })
    //     .catch(error => {
    //       // If there are URL params requesting the daily data
    //       // and an error while fetching the daily data, trigger an error
    //       if (
    //         !isEmpty(payload.params) &&
    //         payload.params.periodType === "daily"
    //       ) {
    //         dispatch(setError404());
    //       }
    //       notification.error({
    //         message: "Error fetching API",
    //         description: "There was an error while fetching the daily data",
    //         top: 100,
    //         duration: 0
    //       });
    //       dispatch(
    //         setPeriodDataKey({
    //           subObj: "periodData",
    //           type: payload.fileType,
    //           period: "daily",
    //           key: "errorFetchingApi",
    //           value: true
    //         })
    //       );
    //     });
    // }
    // function fetchMonthlyBuoyShipMarinePeriod() {
    //   fetchData(
    //     `${WDQMS_API}/monthly-periods/?file_type=${payload.fileType}&format=json`
    //   ).then(response => {
    //     if (response.data.length === 0) {
    //       dispatch(
    //         setPeriodDataKey({
    //           subObj: "periodData",
    //           type: payload.fileType,
    //           period: "monthly",
    //           key: "noData",
    //           value: true
    //         })
    //       );
    //     } else {
    //       if (!dailyFetched) {
    //         dispatch(
    //           setProperty({
    //             type: payload.fileType,
    //             key: "selectedPeriodType",
    //             value: "monthly"
    //           })
    //         );
    //       }
    //       dispatch(
    //         updatePeriodTypes({
    //           type: payload.fileType,
    //           value: "monthly"
    //         })
    //       );
    //       let tempObj = {};
    //       for (let p of response.data) {
    //         if (!tempObj[p.center]) {
    //           tempObj[p.center] = {};
    //           tempObj[p.center][p.file_type] = {};
    //         } else if (!tempObj[p.center][p.file_type]) {
    //           tempObj[p.center][p.file_type] = {};
    //         }

    //         tempObj[p.center][p.file_type][moment.utc(p.date).format("YYYY-MM")] = {
    //           id: p.id
    //         };
    //       }
    //       // // The object that contains the dates for the 'consistent version (all centers)
    //       let objectAll = {};
    //       // loop through all centers
    //       for (let ct of Object.keys(tempObj)) {
    //         // loop through buoy and ship
    //         for (let f_type of Object.keys(tempObj[ct])) {
    //           // loop through all dates
    //           if (!Object.keys(objectAll).includes(f_type)) {
    //             objectAll[f_type] = {};
    //           }
    //           for (let d of Object.keys(tempObj[ct][f_type])) {
    //             // if the date is not in arrayAll, add it
    //             // if objectAll doesn't have the key 'd'
    //             if (!Object.keys(objectAll[f_type]).includes(d)) {
    //               objectAll[f_type][d] = {};
    //             }
    //             objectAll[f_type][d][ct] = tempObj[ct][f_type][d].id;
    //           }
    //         }
    //       }
    //       // Add objectAll to tempObj
    //       tempObj.all = objectAll;
    //       dispatch(
    //         setPeriodDataKey({
    //           subObj: "periodData",
    //           type: payload.fileType,
    //           period: "monthly",
    //           key: "dates",
    //           value: tempObj
    //         })
    //       );
    //       dispatch(
    //         setPeriodDataKey({
    //           subObj: "periodData",
    //           type: payload.fileType,
    //           period: "monthly",
    //           key: "centers",
    //           value: Object.keys(tempObj).sort(function(a, b) {
    //             return a.toLowerCase().localeCompare(b.toLowerCase());
    //           })
    //         })
    //       );
    //       if (
    //         !isEmpty(payload.params) &&
    //         payload.params.periodType === "monthly"
    //       ) {
    //         dispatch(
    //           setProperty({
    //             type: payload.fileType,
    //             key: "selectedCenter",
    //             value: payload.params.center
    //           })
    //         );
    //         // if the date doesn't exist for this center,
    //         // set "selectedDate" to its latest date
    //         // note: it can happen that a date is available
    //         // for the six-hour periods but not for the daily
    //         if (!tempObj[payload.params.center][payload.params.date]) {
    //           const latestDate = Object.keys(
    //             tempObj[payload.params.center]
    //           ).sort()[
    //             Object.keys(tempObj[payload.params.center]).length - 1
    //           ];
    //           dispatch(
    //             setProperty({
    //               type: payload.fileType,
    //               key: "selectedDate",
    //               value: latestDate
    //             })
    //           );
    //         } else {
    //           dispatch(
    //             setProperty({
    //               type: payload.fileType,
    //               key: "selectedDate",
    //               value: payload.params.date
    //             })
    //           );
    //         }
    //       } else if (!dailyFetched) {
    //         // Case no param - this should only be done
    //         // when there was an error fetching the six-hour data
    //         const firstCenter = Object.keys(tempObj).sort(function(a, b) {
    //           return a.toLowerCase().localeCompare(b.toLowerCase());
    //         })[0];

    //         dispatch(
    //           setProperty({
    //             type: payload.fileType,
    //             key: "selectedCenter",
    //             value: firstCenter
    //           })
    //         );

    //         const latestDate = Object.keys(tempObj[firstCenter]).sort()[
    //           Object.keys(tempObj[firstCenter]).length - 1
    //         ];

    //         dispatch(
    //           setProperty({
    //             type: payload.fileType,
    //             key: "selectedDate",
    //             value: latestDate
    //           })
    //         );
    //       }
    //       if (
    //         isEmpty(payload.params) ||
    //         payload.params.periodType === "monthly"
    //       ) {
    //         dispatch(
    //           setProperty({
    //             type: payload.fileType,
    //             key: "readyToFillMenu",
    //             value: true
    //           })
    //         );
    //       }
    //     }
    //   });
    // }
  };
};
